export default __webpack_public_path__ + "static/dave-1eee2c583335e321876945179cb76e05.png";